import { useTranslation as useTranslationOrg } from 'react-i18next';
import { useEffect } from 'react';

const defaultNS = 'common';
const runsOnServerSide = typeof window === 'undefined';

export function useTranslation(
  lng?: string,
  ns: string | string[] = defaultNS,
  options: Record<string, unknown> = {}
) {
  const globalLocale = (global as Record<string, unknown>).locale as
    | string
    | undefined;

  const ret = useTranslationOrg(ns, options);
  const { i18n } = ret;

  useEffect(() => {
    if (lng && i18n.resolvedLanguage !== lng) {
      i18n.changeLanguage(lng);
    } else if (
      runsOnServerSide &&
      i18n.resolvedLanguage !== globalLocale &&
      globalLocale
    ) {
      i18n.changeLanguage(globalLocale);
    }
  }, [lng, i18n, globalLocale]);

  return ret;
}
